import axios from "axios";
import { spinnerService } from "components/Spinner";
import config from "config";

let API = axios.create({
  baseURL: config.api
});

API.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (!spinnerService.isShowing("mySpinner"))
      spinnerService.show("mySpinner");
    return config;
  },
  function(error) {
    // Do something with request error
    if (spinnerService.isShowing("mySpinner")) spinnerService.hide("mySpinner");
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (spinnerService.isShowing("mySpinner")) spinnerService.hide("mySpinner");
    return response;
  },
  function(error) {
    // Do something with response
    if (spinnerService.isShowing("mySpinner")) spinnerService.hide("mySpinner");
    return Promise.reject(error);
  }
);
export default API;
export const endPoints = {
  actionUrl: "action",
  enumUrl: "enum",
  LinksUrl: "links",
  securityUrl: "security"
};
export const httpStatusCodes = {
  ok: 200,
  badRequest: 400,
  unauthorized: 401,
  notFound: 404,
  internalServerError: 500
};
export const httpMethods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE"
};
export function handleApiCall(httpMethod, apiUrl, data) {
  switch (httpMethod) {
    case httpMethods.get:
      return API.get(apiUrl)
        .then(handleApiErrors)
        .then(response => ({ response }))
        .catch(error => ({ error }));
    case httpMethods.post:
      return API.post(apiUrl, data)
        .then(handleApiErrors)
        .then(response => ({ response }))
        .catch(error => ({ error }));
    case httpMethods.put:
      return API.put(apiUrl, data)
        .then(handleApiErrors)
        .then(response => ({ response }))
        .catch(error => ({ error }));
    case httpMethods.delete:
      return API.delete(apiUrl, data)
        .then(handleApiErrors)
        .then(response => ({ response }))
        .catch(error => ({ error }));
    default:
      return API.get(apiUrl, data)
        .then(handleApiErrors)
        .then(response => ({ response }))
        .catch(error => ({ error }));
  }
}
export function handleApiErrors(response) {
  if (response.status !== httpStatusCodes.ok) throw Error(response.statusText);
  return response;
}
export const MLAPI = {
  action: {
    saveAction: actionRequest => {
      return handleApiCall(
        httpMethods.post,
        `${endPoints.actionUrl}`,
        actionRequest
      );
    }
  },
  enum: {
    getActions: () => {
      return handleApiCall(httpMethods.get, `${endPoints.enumUrl}/actions`);
    }
  },
  links: {
    getLinks: () => {
      return handleApiCall(httpMethods.get, `${endPoints.linksUrl}`);
    }
  },
  security: {
    getUser: () => {
      return handleApiCall(httpMethods.get, `${endPoints.securityUrl}/user`);
    }
  }
};
